class AxiosApiClient {
  constructor(apiUrl = "", { headers = {} } = {}) {
    if (!apiUrl) throw new Error("missing apiUrl");
    this.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    Object.assign(this.headers, headers);
    this.apiUrl = apiUrl;
  }

  fullRoute(url) {
    return `${this.apiUrl}${url}`;
  }

  fetch(route, method, body, isQuery = false, customHeaders = {}) {

    if (!route) throw new Error("Route is undefined");

    let fullRoute = this.fullRoute(route);

    if (isQuery && body) {
      const querys = Object.keys(body)
        .map((key) => {
          return `?${key}=${body[key]}`;
        })
        .join();
      fullRoute = `${fullRoute}${querys}`;
      body = undefined;
    }
    const headers = Object.assign({}, this.headers, customHeaders);
    let opts = {
      method,
      headers
    };
    if (body) {
      switch (headers['Content-Type']) {
        case 'application/json':
          body = JSON.stringify(body);
          break;
        case 'text':
        case 'text/plain':
          if (typeof body !== 'string') {
            body = body.toString();
          }
          break;
        case 'multipart/form-data':
          let nbody = new FormData();
          Object.keys(body).forEach((k) => nbody.append(k, body[k]));
          body = nbody;
          delete opts.headers['Content-Type'];
          break;
        default:
          throw Error(`Can't to cast ${headers['Content-Type']} Content-Type`);
      }
    }
    
    Object.assign(opts, { body });
    const fetchPromise = () => fetch(fullRoute, opts);

    return fetchPromise().then((response) => {
      if (
        (response.url.includes("auth/confirm/sms") ||
          response.url.includes("/auth/resendcode/sms") ||
          response.url.includes("/auth/check")) &&
        response.status === 204
      ) {
        return { success: true };
      } else {
        return response.json();
      }
    });
  }

  GET(route, query) {
    return this.fetch(route, "GET", query, true);
  }
  POST(route, body, headers) {
    return this.fetch(route, "POST", body, false, headers);
  }
  PUT(route, body, headers) {
    return this.fetch(route, "PUT", body, headers);
  }
  PATCH(route, body) {
    return this.fetch(route, "PATCH", body);
  }
  DELETE(route, query) {
    return this.fetch(route, "DELETE", query, true);
  }
}

export default AxiosApiClient;
